import { createDeployPluginHeadless } from '../../_shared/common/createDeployPluginHeadless';
import { MS_CAPABILITIES } from '../capabilities';
import { MS_FIELD_KEYS } from '../fields';
import { MS_MODULES } from '../modules';
import { msMigrations, normalizeMsPresetToSpec } from './migrations';
import { buildMsDisplayDescriptors, buildMsResourceConfigs, pickMsPresetFields, serializeMsApiBody } from './projections';
import { type MsApiPayload, type MsSpec, MsSpecSchema } from './schema';
import { msFromForm, msGetInitialFormValues, msToForm } from './spec';

const msBaseHeadless = createDeployPluginHeadless<MsSpec, MsApiPayload, (typeof MS_FIELD_KEYS)[number]>({
  code: 'ModelSubscription',
  fieldKeys: MS_FIELD_KEYS,
  modules: MS_MODULES,
  capabilities: MS_CAPABILITIES,
  schema: MsSpecSchema,
  fromForm: msFromForm,
  toForm: msToForm,
  getInitialFormValues: msGetInitialFormValues,
  projectionProfile: {
    profile: 'sku-capable',
    projections: {
      apiBody: serializeMsApiBody,
      skuPreset: pickMsPresetFields,
      buildDisplayDescriptors: (spec, ctx) => buildMsDisplayDescriptors(spec, ctx),
      skuResources: buildMsResourceConfigs,
    },
  },
  migrations: msMigrations,
});

export const msPipelineKernel = msBaseHeadless.pipeline;

/** SKU preset（当前扁平表单或完整 MsSpec）规范化后再 parse */
export const msPipeline = {
  ...msPipelineKernel,
  parseSpec: (input: unknown) => msPipelineKernel.parseSpec(normalizeMsPresetToSpec(input)),
};

export const msHeadless = {
  ...msBaseHeadless,
  pipeline: msPipeline,
};

export { buildMsDeliveryMetadata, buildMsOrderDeliveryMetadata } from './deliveryMetadata';
export type {
  BuildMsDeliveryMetadataInput,
  BuildMsOrderDeliveryMetadataContext,
  ModelSubscriptionDeliveryMetadata,
} from './deliveryMetadata';
